
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
	props: {
		setClose: {
			default: false,
			type: Boolean,
		},
		show: {
			required: true,
			type: Boolean,
		},
	},
	setup(props, { emit }) {
		const showContent = ref(false);

		const closeModal = () => {
			showContent.value = false;
			setTimeout(() => emit('close', false), 200);
		};

		watch(
			() => props.setClose,
			n => n && closeModal()
		);

		return { closeModal, showContent };
	},
});
